<template>
  <img class="loader-image" src="../../../public/gifs/loader.gif" />
</template>

<script>
export default {
  name: "loader"
};
</script>

<style>
.loader-image {
  width: 100%;
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-width: 441px;
}
</style>